import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AmenityKey } from '@root/types/Listing';
import actions from '@store/actions/listingSearchPage';
import { useMemo } from 'react';
import { OptionTypeBase, ValueType } from '../../FilterDropdown/types';
import { amenityOptions } from '../../utils/constants';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import useListingSearchCriteria from '../../utils/useListingSearchCriteria';

const AmenitiesFilter = () => {
  const { t } = useTranslation('filters');

  const criteria = useListingSearchCriteria();
  const dispatch = useDispatch();

  const orderedAmenities = useMemo(
    () =>
      amenityOptions.sort((amenityA, amenityB) =>
        t(amenityA.label).localeCompare(t(amenityB.label)),
      ),
    [amenityOptions],
  );

  const translatedOptions = orderedAmenities.map(option => {
    return { ...option, label: t(option.label) };
  });

  const currentFilterOptions =
    translatedOptions.filter(option =>
      criteria.currentFilters.amenities?.includes(option.value as AmenityKey),
    ) || [];

  const handleChange = (currentValues: ValueType<OptionTypeBase>) => {
    criteria.add(
      'amenities',
      currentValues?.map(option => option.value as AmenityKey),
    );
    criteria.pushToHistory();
    dispatch(actions.amenitiesFilterChanged(criteria.currentFilters.amenities as string[]));
  };

  return (
    <div className="u-p-top-2x">
      <FilterDropdown
        name="amenities"
        options={translatedOptions}
        value={currentFilterOptions}
        onChange={handleChange}
        placeholder={t('amenities.placeholder')}
      />
    </div>
  );
};

export default AmenitiesFilter;
